export default function ShrtContainer({ children }: { children: React.ReactNode }) {
  return <div className="min-h-full bg-scroll bg-white dark:bg-gray-800 px-8 pt-8">{children}</div>;
}
